<template>
  <div class="preview-page">
    <div class="preview-header">
      <div class="preview-header-inner">
        <div class="preview-title">
          <v-icon color="white" class="mr-2">mdi-file-document-outline</v-icon>
          Terms &amp; Conditions
        </div>
        <div class="lang-switcher">
          <button class="lang-btn" :class="{ active: lang === 'sq' }" @click="switchLang('sq')">
            🇦🇱 Shqip
          </button>
          <button class="lang-btn" :class="{ active: lang === 'en' }" @click="switchLang('en')">
            🇬🇧 English
          </button>
        </div>
      </div>
    </div>

    <div class="preview-body">
      <vue-element-loading :active="isLoading" />
      <div v-if="!isLoading && content" class="preview-content ql-editor" v-html="content"></div>
      <div v-if="!isLoading && !content" class="preview-empty">
        <v-icon size="48" color="grey lighten-2">mdi-file-document-outline</v-icon>
        <p>{{ $t('messages.no_content_for_language') }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import VueElementLoading from 'vue-element-loading'
import 'quill/dist/quill.core.css'

export default {
  components: { VueElementLoading },
  data() {
    return {
      isLoading: false,
      lang: 'sq',
      content: '',
    }
  },
  mounted() {
    this.load('sq')
  },
  methods: {
    switchLang(l) {
      this.lang = l
      this.load(l)
    },
    load(l) {
      this.isLoading = true
      this.content = ''
      axios.get('/docs/terms', { params: { lang: l } })
        .then(res => { this.content = res.data.terms || '' })
        .catch(() => {})
        .finally(() => { this.isLoading = false })
    },
  },
}
</script>

<style scoped>
.preview-page { min-height: 100vh; background: #f5f5f5; }
.preview-header { background: linear-gradient(90deg, #1B5E20, #388E3C); padding: 16px 24px; position: sticky; top: 0; z-index: 10; }
.preview-header-inner { max-width: 860px; margin: 0 auto; display: flex; align-items: center; justify-content: space-between; }
.preview-title { color: #fff; font-size: 16px; font-weight: 700; display: flex; align-items: center; }
.lang-switcher { display: flex; gap: 8px; }
.lang-btn { padding: 5px 16px; border-radius: 20px; border: 2px solid rgba(255,255,255,0.5); background: transparent; color: rgba(255,255,255,0.8); font-size: 12px; font-weight: 600; cursor: pointer; transition: all 0.15s; }
.lang-btn.active { background: rgba(255,255,255,0.25); border-color: #fff; color: #fff; }
.lang-btn:hover:not(.active) { border-color: #fff; color: #fff; }
.preview-body { max-width: 860px; margin: 32px auto; background: #fff; border-radius: 12px; padding: 40px 48px; box-shadow: 0 2px 12px rgba(0,0,0,0.08); min-height: 400px; }
.preview-empty { text-align: center; padding: 60px; color: #aaa; }
.preview-content { font-size: 15px; line-height: 1.8; color: #333; }
</style>
